import { Box, Paper, Typography, useTheme, alpha } from "@mui/material";
import { ChartCardProps } from "./interface";

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  children,
  height = 300,
  action,
}) => {
  const theme = useTheme();

  const isDark = theme.palette.mode === "dark";

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: height,
        maxWidth: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          borderColor: theme.palette.primary.main + "40",
        },
      }}
    >
      <Box
        sx={{
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: 1.5,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          backgroundColor: isDark
            ? alpha(theme.palette.background.default, 0.5)
            : alpha(theme.palette.grey[50], 0.8),
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 3,
              alignSelf: "stretch",
              borderRadius: 2,
              backgroundColor: theme.palette.primary.main,
            }}
          />
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "0.875rem",
                color: "text.primary",
                letterSpacing: "0.01em",
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  mt: 0.25,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          minHeight: 0,
          width: "100%",
          overflow: "hidden",
          p: { xs: 1.5, sm: 2, md: 2.5 },
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};
